import React,{createContext, useState} from 'react'
import config from '../config.js'

export const DomainContext = createContext()

const DomainProvider = (props) => {
	const [domainName, setDomainName] = useState(undefined)
	const [cloudName, setCloudName] = useState(undefined)

	console.log("ENV:",process.env.REACT_HELP_TC_URL,process.env.REACT_HELP_PERSONAL_URL)

	const handleDomain = (url) => {
		console.log("El config:",config)
		let a = config.find(a=>a.url==url)
		console.log("Find encontro:",a)
		setCloudName(a?.name)
		setDomainName(a?.domain)
	
		document.title = `Ayuda ${a?.name}`
	
		const metaTag = document.querySelector('meta[name="description"]');
		metaTag.setAttribute('content', `Ayuda ${a?.name} web site`);
	}

	return (
		<DomainContext.Provider 
            value={{
				handleDomain,
				domainName,  
				cloudName, 
			}}
		>
			{props.children}
		</DomainContext.Provider>
	)
}

export default DomainProvider
